<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex sm12>
                <v-card>
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                            <h3>FastPost</h3>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <router-link class="link-btn square-btn" :to="{name: 'Trucks'}">
                            <v-icon color="black" medium>fa-chevron-left</v-icon>
                        </router-link>
                    </v-toolbar>
                    <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-form lazy-validation>
                            <v-container grid-list-xl fluid>
                                <v-layout row wrap v-for="index in saveFastPostNumberAtATime" :key="index">
                                    <v-flex lg2 md2 xs12>
                                        <v-menu 
                                            ref="picker_pickup_date"
                                            lazy 
                                            :close-on-content-click="false" 
                                            v-model="picker_pickup_date[index-1]" 
                                            transition="scale-transition" 
                                            offset-y full-width 
                                            :nudge-right="40" 
                                            min-width="290px" 
                                            :return-value.sync="form.available_date[index-1]"
                                            >
                                            <v-text-field 
                                                class="custom-picker-text" 
                                                id="available_date" 
                                                data-vv-name="available_date" 
                                                data-vv-as="Available Date" 
                                                slot="activator" 
                                                label="Available Date" 
                                                :value="displayDate(form.available_date[index-1])" 
                                                prepend-icon="event" 
                                                readonly
                                            >
                                            </v-text-field>
                                            <v-date-picker 
                                                :min="minDate" 
                                                v-model="form.available_date[index-1]" 
                                                no-title 
                                                scrollable 
                                                @input="changePickerDate();$refs.picker_pickup_date[index-1].save(form.available_date[index-1])">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex lg4 md4 xs12>	
                                        <v-autocomplete
                                            class="auotchoice"
                                            :menu-props="{'maxHeight':150}" 
                                            :v-model="`form.equipment_type_code[${index-1}]`"
                                            :items="equipment_types[index-1]"
                                            :readonly="!showEquipmentTypes[index-1] ? true : false" 
                                            label="Equipment Types"
                                            item-text="name" 
                                            item-value="code"
                                            data-vv-as="Equipment Types"
                                            :data-vv-name="`equipment_type_code[${index-1}]`"
                                            :id="`equipment_type_code_${index-1}`"
                                            v-bind:value="form.equipment_type_code[index-1]"
                                            v-on:change="onEquipmentChange(index-1,$event)"
                                            v-validate="{required:`form.equipment_type_code[${index-1}]`}" 
                                            :error-messages="errors.collect(`equipment_type_code[${index-1}]`)"
                                            required
                                            multiple
                                            clearable
                                        >
                                            <template
                                                slot="selection"
                                                slot-scope="data"
                                            >
                                                <v-chip
                                                    data-vv-scope="form"
                                                    :selected="data.selected"
                                                    class="v-chip--select-multi"
                                                    @input="removeEquipmentTypeChip(index-1,data.item.code)"
                                                    close
                                                >
                                                    {{ data.item.name }}
                                                </v-chip>
                                            </template>
                                        </v-autocomplete>
                                    </v-flex>
                                    <v-flex lg2 md2 xs12>		
                                        <v-select 
                                            class="custom_dropdown" 
                                            :items="load_size_arr" 
                                            :data-vv-name="`load_size[${index-1}]`" 
                                            :v-model="`form.load_size[${index-1}]`" 
                                            data-vv-as="Load Size" 
                                            item-text="name" 
                                            item-value="id" 
                                            label="Load Size"
                                            v-bind:value="form.load_size[index-1]"
                                            @change="onLoadSizeChange(index-1,$event)"
                                        >		
                                        </v-select>		
                                    </v-flex>
                                    <v-flex lg2 md2 xs12>		
                                        <v-text-field
                                            label="Origin" 
                                            class="white-placeholder" 
                                            autocomplete="off" 
                                            :v-model="`form.origin_address[${index-1}]`" 
                                            :id="`origin_address_${index-1}`" 
                                            :data-vv-name="`origin_address[${index-1}]`" 
                                            data-vv-as="Origin Address" 
                                            v-validate="{required:is_origin_required[index-1],origin_address: [hidden_origin_address[index-1]], origin_city_check: [hidden_origin_city[index-1], hidden_origin_state[index-1]]}"
                                            :error-messages="errors.collect(`origin_address[${index-1}]`)"
                                            @input="getAddressData('origin',index-1,$event)"
                                            v-bind:value="form.origin_address[index-1]"
                                            >		
                                        </v-text-field>
                                        <input 
                                            :type="'hidden'" 
                                            :v-model="`hidden_origin_address[${index-1}]`" 
                                            ref="hidden_origin_address" 
                                            :data-vv-name="`hidden_origin_address[${index-1}]`" 
                                        />		
                                        <input 
                                            :type="'hidden'" 
                                            :v-model="`hidden_origin_city[${index-1}]`" 
                                            ref="hidden_origin_city" 
                                            :data-vv-name="`hidden_origin_city[${index-1}]`"
                                        />		
                                        <input 
                                            :type="'hidden'" 
                                            :v-model="`hidden_origin_state[${index-1}]`" 
                                            ref="hidden_origin_state" 
                                            :data-vv-name="`hidden_origin_state[${index-1}]`"
                                        />		
                                    </v-flex>
                                    <v-flex lg2 md2 xs12>
                                        <v-text-field
                                            label="Destination"  
                                            autocomplete="off" 
                                            :v-model="`form.dest_address[${index-1}]`" 
                                            :id="`dest_address_${index-1}`" 
                                            :data-vv-name="`dest_address[${index-1}]`" 
                                            data-vv-as="Destination Address" 
                                            placeholder="Anywhere"
                                            v-validate="{dest_address: [hidden_dest_address[index-1]], dest_city_check: [hidden_dest_city[index-1], hidden_dest_state[index-1]], dest_address_mismatch:[form.origin_lat[index-1],form.origin_lng[index-1], form.dest_lat[index-1],form.dest_lng[index-1]]}"
                                            :error-messages="errors.collect(`dest_address[${index-1}]`)"
                                            @input="getAddressData('dest',index-1,$event)"
                                            v-bind:value="form.dest_address[index-1]"
                                            >
                                        </v-text-field>
                                        <input 
                                            :type="'hidden'" 
                                            :v-model="`hidden_dest_address[${index-1}]`" 
                                            ref="hidden_dest_address" 
                                            :data-vv-name="`hidden_dest_address[${index-1}]`" 
                                        />		
                                        <input 
                                            :type="'hidden'" 
                                            :v-model="`hidden_dest_city[${index-1}]`" 
                                            ref="hidden_dest_city" 
                                            :data-vv-name="`hidden_dest_city[${index-1}]`"
                                        />		
                                        <input 
                                            :type="'hidden'" 
                                            :v-model="`hidden_dest_state[${index-1}]`" 
                                            ref="hidden_dest_state" 
                                            :data-vv-name="`hidden_dest_state[${index-1}]`"
                                        />		
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <v-flex  xs12 style="position:fixed;bottom:56px;right:24px;z-index:999; background:#fff
                            padding:10px;">
                                <div class="form-btn text-xs-right">
                                    <v-layout align-center justify-end fill-height>
                                        <v-flex xs12 style="padding: 6px;">
                                            <v-btn color="gray white--text" :to="{name:'Trucks'}"> 
                                                <v-icon color="white">fa-times-circle</v-icon>
                                                Cancel
                                            </v-btn>
                                            <v-btn color="green white--text" @click="submit">
                                                <v-icon color="white">fa-cube</v-icon>
                                                Post Truck 
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>
<script>
const ADDRESS_COMPONENTS = {
    subpremise: 'short_name',
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'long_name',
    administrative_area_level_2: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
};
import GoogleAds from "@/pages/widgets/GoogleAds";
import services from "../../services/HttpService";
import breadcrumbs from "../widgets/Breadcrumb";
import axios from "axios";
import moment from 'moment';
import VWidget from '@/components/VWidget';
import { ErrorBag, Validator } from 'vee-validate';
import config from "../../config";
import utils from '../../util/';
import { setTimeout } from 'timers';
import commonServices from "../../services/CommonService";
Validator.extend('origin_address', {
    getMessage: field => 'The ' + field + ' field is Invalid.',
    validate: function (value, [oth]) {
        if (oth == '') {
            return false;
        }
        return true;
    }
});
Validator.extend('origin_city_check', {
    getMessage: field => config.validationMsgForCityCheck,
    validate: function (value, [city, state]) {
        return true;
    }
});
Validator.extend('dest_city_check', {
    getMessage: field => config.validationMsgForCityCheck,
    validate: function (value, [city, state]) {
        return true;
    }
});
Validator.extend('dest_address', {
    getMessage: field => 'The ' + field + ' field is Invalid.',
    validate: function (value, [oth]) {
        if (oth == '') {
            return false;
        }
        return true;
    }
});
Validator.extend('dest_address_mismatch', {
    getMessage: field => config.validationMsgForOriginDestNotSame,
    validate: function (value, [origin_lat, origin_lng, dest_lat, dest_lng]) {
        if (origin_lat != '' && dest_lat != '' && origin_lng != '' && dest_lng != '' && origin_lat == dest_lat && origin_lng == dest_lng) {
            return false;
        }
        return true;
    }
});
export default {
    $_veeValidate: {
        validator: 'new'
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === 'Login') {
            next();
        } else {
            if (this.canLeaveWithoutPrompt) {
                return next();
            }
            next(window.confirm(config.msgForLeavePage));
        }
    },
    data: () => ({
        canLeaveWithoutPrompt: false,
        saveFastPostNumberAtATime:config.saveFastPostNumberAtATime,
        anyStrId:config.ANYStr,
        form:{
            available_date: [],
            equipment_type_code:[],
            load_size:[],
            origin_address:[],
            origin_country: [],
            origin_state: [],
            origin_city: [],
            origin_pincode: [],
            origin_lat: [],
            origin_lng: [],
            origin_short_name:[],
            origin_radius: [],
            dest_address: [],
            dest_country: [],
            dest_state: [],
            dest_city: [],
            dest_pincode: [],
            dest_lat: [],
            dest_lng: [],
            dest_short_name: [],
            dest_radius: [],
        },
        showEquipmentTypes: [],
        equipment_types: [],
        load_size_arr: [],
        picker_pickup_date:[],
        origin_autocomplete:[],
        hidden_origin_address:[],
        hidden_origin_city:[],
        hidden_origin_state:[],
        dest_autocomplete:[],
        hidden_dest_address:[],
        hidden_dest_city:[],
        hidden_dest_state:[],
        is_dest_required:[],
        is_origin_required:[],
        breadcrumbs: [{
                name: 'Dashboard',
                to: "/dashboard",
                disabled: false
            },
            {
                name: 'Broker/Shipper',
                disabled: true
            },
            {
                name: 'Fast Posts',
                disabled: true
            }
        ]
    }),
    components: {
        breadcrumbs,
        VWidget,
        GoogleAds
    },
    mounted() {
        const self = this;
        self.form.contact_email = self.$store.state.user.email;
        self.form.contact_name = self.$store.state.user.name;
        self.form.contact_phone = self.$store.state.user.contact_phone_no;
        self.$validator.localize('en', self.dictionary);
        const options = {};
        const options1 = {};
        for(let i=0;i<config.saveFastPostNumberAtATime;i++){
            //INTIALIZING
            self.form.available_date[i] = new Date().toISOString().substr(0, 10);
            self.picker_pickup_date[i] = false;
            self.form.equipment_type_code[i] = [];
            self.equipment_types[i] = [];
            self.showEquipmentTypes[i] = true;
            //ORIGIN ADDRESS
            self.form.origin_address[i] = '';
            self.form.origin_country[i] = '';
            self.form.origin_state[i] = '';
            self.form.origin_city[i] = '';
            self.form.origin_pincode[i] = '';
            self.form.origin_lat[i] = '';
            self.form.origin_lng[i] = '';
            self.form.origin_short_name[i] = '';
            self.form.origin_radius[i] = "50";
            self.hidden_origin_address[i] = '';
            self.hidden_origin_city[i] = '';
            self.hidden_origin_state[i] = '';
            self.is_origin_required[i] = false;
            //DESTINATION ADDRESS
            self.form.dest_address[i] = '';
            self.form.dest_country[i] = '';
            self.form.dest_state[i] = '';
            self.form.dest_city[i] = '';
            self.form.dest_pincode[i] = '';
            self.form.dest_lat[i] = '';
            self.form.dest_lng[i] = '';
            self.form.dest_short_name[i] = '';
            self.form.dest_radius[i] = "50";
            self.hidden_dest_address[i] = '';
            self.hidden_dest_city[i] = '';
            self.hidden_dest_state[i] = '';
            self.is_dest_required[i] = false;
            // google place api for origin address
            let tmpOriginAutoComplete = new google.maps.places.Autocomplete(
                document.getElementById('origin_address_'+i),
                options
            );
            tmpOriginAutoComplete.setComponentRestrictions({
                'country': ['CAN', 'US']
            });
            tmpOriginAutoComplete.addListener('place_changed', function () {
                self.$validator.validate('dest_address['+i+']');
                self.$validator.validate('origin_address['+i+']');
                let place = tmpOriginAutoComplete.getPlace();
                if (place.address_components !== undefined) {
                    self.formatResult(place, 'origin_',i);
                } else {
                    self.hidden_origin_address[i] = '';
                    self.hidden_origin_city[i] = '';
                    self.hidden_origin_state[i] = '';
                    this.$validator.validate('origin_address['+i+']');
                }
            });
            self.origin_autocomplete.push(tmpOriginAutoComplete);
            // google place api for destination address
            let tmpDestinationAutoComplete = new google.maps.places.Autocomplete(
                document.getElementById('dest_address_'+i),
                options1
            );
            tmpDestinationAutoComplete.setComponentRestrictions({
                'country': ['CAN', 'US']
            });
            tmpDestinationAutoComplete.addListener('place_changed', function () {
                self.$validator.validate('dest_address['+i+']');
                self.$validator.validate('origin_address['+i+']');
                let place = tmpDestinationAutoComplete.getPlace();
                if (place.address_components !== undefined) {
                    self.formatResult(place, 'dest_',i);
                } else {
                    self.hidden_dest_address[i] = '';
                    self.hidden_dest_city[i] = '';
                    self.hidden_dest_state[i] = '';
                    this.$validator.validate('dest_address['+i+']');
                }
            });
            self.dest_autocomplete.push(tmpDestinationAutoComplete);
        }
    },
    created() {
        const self = this,
        wApp = window.getApp;
        wApp.$emit("showLoader", {
            show: true
        });
        self.load_size_arr = utils.getLoadSizes();
        axios.all([
            services.get("trucks/templates/list", {
                'Authorization': 'Bearer ' + this.$store.state.user.token
            }),
            services.get("equipments/list", {
                'Authorization': 'Bearer ' + this.$store.state.user.token
            }),
        ])
        .then(axios.spread(function (templates, equipment_types) {
            wApp.$emit("showLoader", {
                show: false
            });
            if (equipment_types.data.data.length > 0) {
                let anyEquipmentTypes = {
                    "code":config.ANYStr,
                    "name":config.ANYStr,
                    // "disabled":config.equipmentTypesDisableDefaultValue
                };
                equipment_types.data.data.unshift(anyEquipmentTypes);
                equipment_types.data.data.map(function (data) {
                    let newArr = {};
                    newArr.name = data.name;
                    newArr.code = data.code;
                    // newArr.disabled = config.equipmentTypesDisableDefaultValue;
                    for(let i=0;i<config.saveFastPostNumberAtATime;i++){
                        self.equipment_types[i].push(newArr);
                        if(data.code && data.code == 'VAN'){
                            self.form.load_size.push(self.load_size_arr[2].id);
                            self.form.equipment_type_code[i].push(newArr.code);
                        }
                    }
                });
            } else {
                for(let i=0;i<config.saveFastPostNumberAtATime;i++){
                    self.showEquipmentTypes[i].push(false);
                }
            }
        }))
        .catch(function (err) {
            wApp.$emit("showLoader", {
                show: false
            });
            self._showToast(err.message, config.errMsgColorStr);
        });
    },
    computed: {
        minDate() {
            const today = new Date();
            return this.formatDate(today);
        }
    },
    methods: {
        /**
         * Format result from Geo google APIs
         * @param place
         * @returns {{formatted output}}
         */
        formatResult: function (place, address,index) {
            const self = this;
            self['hidden_' + address + 'address'][index] = '';
            self['hidden_' + address + 'city'][index] = '';
            self['hidden_' + address + 'state'][index] = '';
            self.$validator.validate(address + 'address['+index+']');
            let returnData = {};
            for (let i = 0; i < place.address_components.length; i++) {
                let addressType = place.address_components[i].types[0];
                if(addressType == 'administrative_area_level_1'){
                    self.form[address + 'short_name'][index] = place.address_components[i].short_name;
                }
                if (ADDRESS_COMPONENTS[addressType]) {
                    let val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                    returnData[addressType] = val;
                }
            }
            returnData['latitude'] = place.geometry.location.lat();
            self.form[address + 'address'][index] = '';
            self.$set(self.form,address + 'address['+index+']',place.formatted_address);
            self.form[address + 'address'][index] = place.formatted_address;
            self['hidden_' + address + 'address'][index] = place.formatted_address;
            self['hidden_' + address + 'city'][index] = returnData.locality;
            self['hidden_' + address + 'state'][index] = returnData.administrative_area_level_1;
            self.form[address + 'city'][index] = returnData.locality;
            self.form[address + 'state'][index] = returnData.administrative_area_level_1;
            self.form[address + 'country'][index] = returnData.country;
            self.form[address + 'pincode'][index] = returnData.postal_code;
            self.form[address + 'lat'][index] = place.geometry.location.lat();
            self.form[address + 'lng'][index] = place.geometry.location.lng();
            if(self.form[address + 'address'][index].length > 0){
                self.is_dest_required[index] = true;
                self.is_origin_required[index] = true;
            }else{
                self.is_dest_required[index]=false;
                self.is_origin_required[index]= false; 
            }
        },
        getAddressData(data,index,value) {
            const self = this;
            self.form[data+'_address'][index] = value;
            self['hidden_' + data + '_address'][index] = '';
            self['hidden_' + data + '_city'][index] = '';
            self['hidden_' + data + '_state'][index] = '';
            self.$validator.validate(data + '_address['+index+']');
            if(value.length == 0){
                if(self.form.origin_address[index].length == 0 && self.form.dest_address[index].length == 0){
                    self.is_origin_required[index]=false;
                    self.is_dest_required[index]=false;
                }
            }
        },
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        distanceOrgToDest(lat1, lon1, lat2, lon2, cb) {
            const self = this;
            if ((lat1 == lat2) && (lon1 == lon2)) {
                self.form.distance = 0;
                return 0;
            } else {
                var origin1 = new google.maps.LatLng(lat1, lon1);
                var destinationB = new google.maps.LatLng(lat2, lon2);
                let inMiles = 0;
                var distanceService = new google.maps.DistanceMatrixService();
                distanceService.getDistanceMatrix({
                        origins: [origin1, ''],
                        destinations: [destinationB, ''],
                        travelMode: google.maps.TravelMode.DRIVING,
                        unitSystem: google.maps.UnitSystem.IMPERIAL,
                        durationInTraffic: true,
                        avoidHighways: false,
                        avoidTolls: false
                    },
                    function (response, status) {
                        if (status !== google.maps.DistanceMatrixStatus.OK) {
                            console.log('Error:', status);
                            cb(inMiles);
                        } else {
                            if(response.rows[0].elements[0].status === 'ZERO_RESULTS'){
                                var radlat1 = Math.PI * lat1 / 180;
                                var radlat2 = Math.PI * lat2 / 180;
                                var theta = lon1 - lon2;
                                var radtheta = Math.PI * theta / 180;
                                var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                                if (dist > 1) {
                                    dist = 1;
                                }
                                dist = Math.acos(dist);
                                dist = dist * 180 / Math.PI;
                                dist = dist * 60 * 1.1515;
                                inMiles = dist * 0.8684;
                            } else {
                                inMiles = parseFloat(response.rows[0].elements[0].distance.value / 1609.34).toFixed(2);
                            }
                            cb(inMiles.toString());
                        }
                    });
            }
        },
        submit() {
            const self = this;
            const wApp = window.getApp;
            self.$validator.validateAll()
                .then(isValid => {
                    if (isValid) {
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        self.createRequestObject().then(function(requestObject){
                            if(requestObject.length == 0){
                                self._showToast(config.errMsgForFastPostCheckRecordCount, config.errMsgColorStr);    
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                            }else{
                                let count = 0;
                                requestObject.map(function(object,index){
                                    self.distanceOrgToDest(object.origin_lat,
                                    object.origin_lng,object.dest_lat,object.dest_lng,function(dest){
                                        count++;
                                        requestObject[index]["distance"] = dest.toString();
                                        if(count==requestObject.length){
                                            services.post("trucks/fast-post", {'truck_posts':JSON.stringify(requestObject)}, {
                                                "Authorization": "Bearer " + self.$store.state.user.token
                                            })
                                            .then(res => {
                                                wApp.$emit("showLoader", {
                                                    show: false
                                                });
                                                if (!res.data.is_err) {
                                                    self._showToast(res.data.message);
                                                    self.canLeaveWithoutPrompt = true;
                                                    self.$router.push({
                                                        name: "Trucks"
                                                    });
                                                } else {
                                                    self._showToast(res.data.message, config.errMsgColorStr);
                                                }
                                            })
                                            .catch(err => {
                                                wApp.$emit("showLoader", {
                                                    show: false
                                                });
                                                self._showToast(err.message, config.errMsgColorStr);
                                            });
                                        }
                                    });
                                });
                            }
                        });
                    } else {
                        self._showToast(config.errMsgFormSubmitValidation, config.errMsgColorStr);
                    }
                })
        },
        createRequestObject(){
            const self = this;
            return new Promise((resolve)=>{
                let requestObject = [];
                for(let i=0;i<config.saveFastPostNumberAtATime;i++){
                    if(self.form.origin_address[i].length > 0){
                        let loadPostObject = {
                            "origin_address":self.form.origin_address[i].toString(),
                            "origin_lat":self.form.origin_lat[i].toString(),
                            "origin_lng":self.form.origin_lng[i].toString(),
                            "origin_city":self.form.origin_city[i] ? self.form.origin_city[i].toString() : '',
                            "origin_state":self.form.origin_state[i] ? self.form.origin_state[i].toString() : '',
                            "origin_country":self.form.origin_country[i].toString(),
                            "origin_pincode":typeof self.form.origin_pincode[i] != 'undefined' ? self.form.origin_pincode[i].toString() : '',
                            "origin_short_name":self.form.origin_short_name[i].toString(),
                            "origin_radius":self.form.origin_radius[i],
                            "available_date":self.form.available_date[i].toString(),
                            "load_size":self.form.load_size[i].toString(),
                            "equipment_type_id":self.form.equipment_type_code[i].map(function(equipment_data){return equipment_data}).join(',').toString(),
                            "dest_address":self.form.dest_address[i] ? self.form.dest_address[i].toString() : '',
                            "dest_lat":self.form.dest_lat[i] ? self.form.dest_lat[i].toString() : '',
                            "dest_lng":self.form.dest_lng[i] ? self.form.dest_lng[i].toString() : '',
                            "dest_city":self.form.dest_city[i] ? self.form.dest_city[i].toString() : '',
                            "dest_state":self.form.dest_state[i] ? self.form.dest_state[i].toString() : '',
                            "dest_country":self.form.dest_country[i].toString(),
                            "dest_pincode":typeof self.form.dest_pincode[i] != 'undefined' ? self.form.dest_pincode[i].toString() : '',
                            "dest_short_name":self.form.dest_short_name[i].toString(),
                            "dest_radius":self.form.dest_radius[i],
                            "contact_email":self.$store.state.user.email.toString(),
                            "contact_name":self.$store.state.user.name.toString(),
                            "contact_phone":self.$store.state.user.contact_phone_no.toString()
                        };
                        requestObject.push(loadPostObject);
                    }
                }
                resolve(requestObject);
            });
        },
        clear() {
            this.form = {};
            this.$validator.reset();
        },
        displayDate(selectedDate){
            return moment(selectedDate).format(config.displayDateFormat);
        },
        onEquipmentChange(index,data) {
            const self = this;
            if(data != ''){
                let selectedEquipmentCode = data.toString().split(',');
                self.form.equipment_type_code[index] = [];
                if(selectedEquipmentCode[(selectedEquipmentCode.length -1)]==config.ANYStr){
                    self.form.equipment_type_code[index].push(config.ANYStr);
                }else{
                    selectedEquipmentCode.map(async function (equipmentCode) {
                        if(equipmentCode != config.ANYStr){
                            await self.form.equipment_type_code[index].push(equipmentCode);
                        }        
                    });
                }
            }
        },
        removeEquipmentTypeChip(index,equipmentTypeCode) {
            const self = this;
            self.form.equipment_type_code[index].splice(self.form.equipment_type_code[index].indexOf(equipmentTypeCode),1);
            self.$validator.validate("equipment_type_code["+index+"]");
        },
        onLoadSizeChange(index,event){
            const self = this;
            self.form.load_size[index] = event;
        },
        changePickerDate() {
            const self = this;
            let evt = document.createEvent("HTMLEvents");
            evt.initEvent("input", false, true);
            setTimeout(function () {
                document.getElementById('available_date').dispatchEvent(evt);
            }, 10)
        },
        formatDate(date) {
            let month = `${date.getMonth() + 1}`;
            let day = `${date.getDate()}`;
            const year = date.getFullYear();

            if (month.length < 2) month = `0${month}`;
            if (day.length < 2) day = `0${day}`;

            return [year, month, day].join('-');
        }
    }
};
</script>

<style lang="stylus" scoped>
.payment-method {
    border: 1px solid #eee
}
</style>



// WEBPACK FOOTER //
// src/pages/trucks/FastPost.vue